import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _AccountINFORPO, _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { Alert } from "../../../../theme/Component/Alert";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const CC008 = ({ configProcedure }: Props) => {
    const request = useDataBean(_RequestCredit);
    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ Notification: "ok" })
        }

    }

    useEffect(()=>{
        getReuqest();
    },[])

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        request.instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                request.setBean(resp[0].DataBeanProperties)
                console.log(resp[0].DataBeanProperties)
            }
        ).catch(err => {
            console.log(err)
        })
    }

    const updateCredit = () => {
        const x = request.bean;
        x.StateRequest = 2; 

        request.instance.updateRequestCredit(x).then(
            (resp) => {
                onExportMap();
            }
        ).catch(err => { console.log(err) })
    }


    return (
        <div className="row">
            <div className="col-md-12 mb-2">
                <Alert children={`Felicidades, ya estas a punto de recibir tu Credito`} clase="success" />
            </div>
            <div className="col-md-12">
                <BasicButton eventClick={updateCredit} icon="ri-save-line" children={`Continuar`} />
            </div>
        </div>
    );
};